<template>
  <div class="container">
    <div class="row">
      <div :id="identifier" class="particle-js-container"></div>
    </div>
  </div>
</template>

<script>
import MainStore from "../stores/MainStore";

export default {
  store: MainStore,
  data() {
    return {
      identifier: null,
    };
  },

  mounted: function () {
    this.initialize();
  },

  beforeMount: function () {
    this.identifier = this.getRandomId(5);
  },

  methods: {
    getRandomId: function (len) {
      var text = "";
      var charset = "abcdefghijklmnopqrstuvwxyz";
      for (var i = 0; i < len; i++)
        text += charset.charAt(Math.floor(Math.random() * charset.length));
      return text;
    },

    initialize: function () {
      window.particlesJS(this.identifier, {
        particles: {
          number: { value: 160, density: { enable: true, value_area: 800 } },
          color: { value: "#aacbec" },
          shape: {
            type: "circle",
            stroke: { width: 0, color: "#000000" },
            polygon: { nb_sides: 5 },
            image: { src: "img/github.svg", width: 100, height: 100 },
          },
          opacity: {
            value: 1,
            random: true,
            anim: { enable: true, speed: 1, opacity_min: 0, sync: false },
          },
          size: {
            value: 3,
            random: true,
            anim: { enable: false, speed: 4, size_min: 0.3, sync: false },
          },
          line_linked: {
            enable: false,
            distance: 150,
            color: "#ffffff",
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 1,
            direction: "none",
            random: true,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: { enable: false, rotateX: 600, rotateY: 600 },
          },
        },
        interactivity: {
          detect_on: "window",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "repulse" },
            resize: true,
          },
          modes: {
            grab: { distance: 400, line_linked: { opacity: 1 } },
            bubble: {
              distance: 250,
              size: 0,
              duration: 2,
              opacity: 0,
              speed: 3,
            },
            repulse: { distance: 100, duration: 0.4 },
            push: { particles_nb: 4 },
            remove: { particles_nb: 2 },
          },
        },
        retina_detect: true,
      });

      var update = function () {
        requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
    },
  },

  computed: {},
};
</script>

<style>
canvas {
  display: block;
  vertical-align: bottom;
}
.particle-js-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 20%;
  background-position: 50% 50%;
  z-index: 9;
  left: 0;
}


</style>